import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar40Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar40 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar40Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar40" clipPath="url(#clip0_2286_5386)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M220.148 149.691c0-49.998.167-94.644-44.519-94.644-80.683 0-91.617 27.738-91.617 77.736 0 19.265 8.1 39.637 20.244 57.413-.135 6.952-.462 18.627-1.25 24.529-1.163 8.728-5.033 22.235-5.033 22.235s46.175 37.63 79.185 34.827c13.834.039 12.432-12.376 12.432-12.376s-1.792-10.266-.509-16.446c.302-1.457.836-3.249 1.465-5.129 16.493-6.968 20.181-28.248 28.67-57.747 2.238-13.945.94-13.897.94-30.406l-.008.008Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M176.131 147.541c-9.644-11.866-29.618-3.576-33.417-.143-.526.478-.637 1.386-.255 2.031.231.39.59.589.956.589.239 0 .486-.096.701-.279 1.011-.908 3.384-2.23 6.443-3.353-.008.128-.032.255-.032.391 0 3.496 3.146 6.339 7.016 6.339 3.871 0 7.016-2.835 7.016-6.339a5.83 5.83 0 0 0-.541-2.429c3.95.39 7.701 1.887 10.425 5.248.461.565 1.21.565 1.672 0 .462-.566.462-1.489 0-2.055h.016Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M221.335 147.7c-2.796-3.145-17.489-10.735-24.585.128-.342.517-.342 1.362 0 1.879.342.518.892.518 1.226 0a11.206 11.206 0 0 1 2.366-2.628c.056 3.257 2.994 5.885 6.618 5.885 3.623 0 6.618-2.675 6.618-5.972 0-.367-.04-.717-.112-1.06 3.234 1.123 5.878 2.835 6.833 3.911a.68.68 0 0 0 .518.254c.271 0 .534-.191.701-.541.287-.589.199-1.426-.183-1.864v.008Z"
          fill="#000"
        />
        <Path
          id="Vector_3"
          d="M136.4 140.198s12.32-2.119 22.785-2.119c7.43 0 16.724 1.649 20.188 1.983.852.08 1.697-.247 2.222-.86l1.927-2.254c1.06-1.234.423-3.042-1.226-3.504-5.232-1.473-15.466-4.81-22.498-4.292-10.075.74-17.25 1.091-23.406 11.046h.008Z"
          fill="#000"
        />
        <Path
          id="Vector_4"
          d="M200.015 136.853c-9.421 17.998 4.444 36.005.2 40.353-2.963 3.034-18.469-1.338-17.481 3.879.677 3.153 20.579 4.244 23.613-2.867 2.493-7.033-12.145-28.265-3.608-39.143-1.672 1.513-2.962-1.514-2.724-2.23v.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_5"
          d="M220.069 131.167c-2.087-.294-4.914-.318-7.303-.318-3.719 0-6.069.86-8.076 1.792-3.122 1.441-4.197 3.966-4.412 5.949-.087.828.59 1.521 1.362 1.377 3.09-.557 8.641-1.513 11.978-1.409 2.047.063 4.555.286 6.514.478a846.53 846.53 0 0 0-.063-7.869Z"
          fill="#000"
        />
        <Path
          id="Vector_6"
          d="M189.081 242.981c.303-1.457.836-3.249 1.466-5.129-3.823 1.617-8.331 2.461-13.754 2.461-14.24 0-30.741-7.98-45.841-20.579 11.325 18.357 28.631 38.498 53.741 47.991.733.279 1.45.454 2.142.566 3.345-3.656 2.764-8.864 2.764-8.864s-1.792-10.266-.51-16.446h-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_7"
          d="M189.59 259.419s1.402 12.416-12.432 12.376c-33.01 2.804-79.186-34.826-79.186-34.826L48.39 262.955c27.11 25.254 63.473 40.704 103.444 40.704 29.905 0 57.787-8.649 81.296-23.581l-43.531-20.659h-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_8"
          d="M211.364 200.692s-8.84 1.704-18.699 1.163c-10.911-.598-22.944-3.401-22.944-2.151 0 2.382 16.78 9.796 22.578 9.796 7.597 0 19.392-7.805 19.057-8.816l.008.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <G id="hair" fill={c.hair}>
          <Path
            id="hair_2"
            d="M193.015 186.182s3.711-1.704 6.228-1.306c2.517.398 16.143 14.606 16.438 16.565.294 1.959-4.285 3.958-8.96 3.704-4.667-.263-13.682-7.614-13.682-7.614s-14.566 6.714-17.369 6.921c-2.812.199-18.198-2.007-18.604-3.879-.406-1.871-.168-3.95 5.168-6.666 5.344-2.707 22.116-10.066 24.84-9.971 2.724.096 5.933 2.262 5.933 2.262l.008-.016Z"
          />
          <Path
            id="hair_3"
            d="M229.267 83.582c-8.847-5.288-1.823-17.218-10.289-24.617-8.466-7.398-21.447-4.42-21.447-4.42s-5.001-13.85-14.813-13.754c-9.812.096-15.578 5.67-23.462 6.061-7.884.382-14.614-5.774-24.712-2.883-10.098 2.883-13.372 10.871-19.042 13.754-5.67 2.883-16.541-.191-22.506 7.598-5.965 7.788-3.751 17.6-7.216 23.175-3.464 5.575-11.348 5.192-12.79 13.754-1.441 8.561 4.23 11.444 4.42 17.114.191 5.671-5.67 6.252-4.037 13.754 1.632 7.502 8.41 7.693 10.448 15.163 2.04 7.471-.51 16.629 3.058 22.913 3.56 6.275 17.481 17.99 17.481 17.99l-.716-4.523c-4.19-3.162-8.45-9.031-11.38-16.263-4.93-12.161-4.246-23.573 1.536-25.492 9.613-3.194 14.463 6.379 19.4 18.54.255.637.494 1.266.725 1.903l8.601 3.098s-2.206-21.041-1.354-23.756c.852-2.716 16.295-23.08 16.295-23.08s12.392 3.393 18.5-5.599c6.108-8.991 3.902-24.943 11.707-27.324 7.805-2.373 16.629 10.01 22.06 10.353 5.432.343 7.893-9.142 18.668-4.754 13.642 5.558 11.747 46.326 11.747 46.326s9.039-17.791 9.23-20.579c.191-2.787 8.848-10.194 8.848-15.577 0-5.384-.096-13.563-8.944-18.851l-.016-.024Z"
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5386">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
